// extracted by mini-css-extract-plugin
module.exports = {"content":"SearchPageLayout_content__ZfjE7","closed":"SearchPageLayout_closed__LzYFp","header":"SearchPageLayout_header__p_CzB"};